import { Component, Input, OnInit } from '@angular/core';
import { Theme } from '@models/theme';
import { ThemeService } from '@services/theme.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'vnm-create-theme',
  templateUrl: './create-theme.component.html',
  styleUrls: ['./create-theme.component.scss']
})
export class CreateThemeComponent implements OnInit {
  @Input() themes: Theme[];
  @Input() theme: Theme;

  base: Theme;

  constructor(
    public dialog: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    this.themes = this.config.data.themes;
    this.base = this.themes[0];

    this.theme = {
      id: this.themes.length,
      name: 'Untitled Theme',
      description: '',
      swatches: [],
      properties: {}
    };
  }

  submit() {
    this.themeService.registerTheme(this.theme);
    const newTheme = this.themeService.updateTheme(this.theme.id, this.base.properties);

    this.dialog.close(newTheme);
  }
}
